import React from "react";
import { useDraggable } from "./useDraggable";
import CloseIcon from "@mui/icons-material/Close";
import "./index.scss";

export default function DraggableModal({
    modal,
    stackIndex,
    isFading,
    baseZ,
    bringToFront,
    handleClose,
    ModalComponent
}) {

    const offsetStep = 20;

    const width = modal?.options?.width || 600;

    const {
        ref,
        position,
        handleMouseDown,
        handleTouchStart
    } = useDraggable({
        initialX: (window.innerWidth - width) / 2 + stackIndex * offsetStep,
        initialY: 100 + stackIndex * offsetStep,
        boundary: true,
        onFocus: () => bringToFront(modal.id)
    });

    // console.log("modal:", modal, stackIndex, window.innerWidth, width, position);

    return (
        <div
            ref={ref}
            className={`modal-wrapper ${isFading ? "fade-out" : "fade-in"} ${modal.className || ""}`}
            style={{
                position: "fixed",
                left: position.x > 0 ? position.x : 0,
                top: position.y,
                zIndex: baseZ,
                // width: modal?.options?.width ? (modal?.options?.width + "px") : "inherit",
                transitionDelay: `${stackIndex * 50}ms`
            }}
            onClick={(e) => e.stopPropagation()}
            onMouseDown={() => bringToFront(modal.id)}
        >
            {
                modal.modalProps?.title && 
                <div
                    className="modal-header"
                >
                    <div 
                        className="title"
                        onMouseDown={handleMouseDown}
                        onTouchStart={handleTouchStart}
                    >
                        {modal.modalProps?.title}
                    </div>
                    <div className="close-icon"><CloseIcon onClick={() => handleClose(modal.id, false)} /></div>
                </div>
            }
            

            <ModalComponent
                {...modal.modalProps}
                modalId={modal.id}
                close={(result) => handleClose(modal.id, result)}
            />
        </div>
    );
}